// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_hl","storyDetailAdvertAvatar__image":"c-r_hm"};